import { render, staticRenderFns } from "./problemBugFix.vue?vue&type=template&id=f665ca0a"
import script from "./problemBugFix.vue?vue&type=script&lang=js"
export * from "./problemBugFix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports